import BaseClass from "../BaseClass";

export default class Poll extends BaseClass {
    constructor(element) {
        super(element);

        this.initCallbacks();

        const interval = this.$element.data('interval')
        this.intervalHandle = setInterval(this.onPollCb, interval);
    }

    initCallbacks() {
        const self = this;

        this.onPollCb = function () {
            self.onPoll();
        }
        this.onPollSuccessCb = function (response) {
            self.onPollSuccess(response);
        }
    }

    onPoll() {
        const triesRemaining = this.$element.data('tries-remaining');

        if (triesRemaining != undefined) {
            if (triesRemaining <= 0) {
                this.clearInterval();

                return;
            }

            this.$element.data('tries-remaining', triesRemaining - 1);
        }

        const url = this.$element.data('url');

        $.ajax({
            url: url,
            method: 'POST'
        })
            .then(this.onPollSuccessCb);
    }

    onPollSuccess(response) {
        if (response.success) {
            this.clearInterval();

            this.handleAjaxResponse(response);
        }
    }

    clearInterval() {
        if (this.intervalHandle != null) {
            clearInterval(this.intervalHandle);
            this.intervalHandle = null;
        }
    }

    teardown() {
        this.clearInterval();

        this.teardownCallbacks();
    }

    teardownCallbacks() {
        delete this.onPollCb;
        delete this.onPollSuccessCb;
    }
}